import React from 'react'

export default function TimerNotice({ heading = 'summer recess notice', body }) {
  if (!body) return null

  return (
    <div className='timer-notice dome-rounded-border dome-padding6-12'>
      <div className='timer-notice__heading dome-p3 dome-text-w500'>{heading}</div>
      <div className='timer-notice__body dome-p3'>{body}</div>
    </div>
  )
}
